<template>
  <div class="ProductDetalis">
    <div class="headerBar">
      <img :src="imgUrl" alt="" class="imgPic">
      <div class="detalisInfo">
        <p class="detalisTitle">{{detalisInfo.productName}}</p>
        <div class="detalisText">
          <p v-for="(item, index) in detalisInfo.extra" :key="index"> <span v-if="item.attr"> {{item.attr}} : <label>{{item.value}}</label></span></p>
        </div>
        <p class="corpName"> 商家名称：{{detalisInfo.createCorpName}}</p>
        <p class="detalisPrice">价格：<span class="red"> ￥{{detalisInfo.price / 100 | PriceFilter}}</span></p>
        <div class="submitBtn"  @click='showMask'>联系商家</div>
        <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg='tips.tipsMsg' :duration='tips.duration'></SubmitSuccess>
      </div>
    </div>
    <div class="imgList clearfix">
      <img :src="item.img" :class="{'active': action === index}"  v-for="(item, index) in detalisInfo.thumb" :key="index" @click="showBigPic(index)">
    </div>
    <div class="content">
      <div class="contentTitle">商品详情</div>
      <div class="contentText" ref="text" v-html="detalisInfo.content"></div>
    </div>
    <!-- 弹窗登录 -->
    <MaskLogin v-show='showLogin' @close='showLogin = false;'></MaskLogin>

    <div class='mask' v-show='showMaskFlag'>
      <div class='container'>
        <el-form ref="call" :model="call" class='call_form' :rules='rules'>
          <el-form-item label='附言' prop='msg'>
            <el-input type="textarea" :rows="3" v-model="call.msg"></el-input>
          </el-form-item>
          <el-form-item class='btngroup'>
            <el-button size='mini' class='cancel' @click='cancel'>取消</el-button>
            <el-button size='mini' class='confirm' @click="submit('call')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    let checkUserInput = (rule, value, callback) => {
      if (value.length>100) {
        callback(new Error('输入字数超过100'));
      } else {
        callback();
      }
    };
    return{
      // productionId: '',
      detalisInfo: {},
      imgUrl: '',
      action: 0,
      showMaskFlag: false,
      submitSuccessFlag: false,
      call: {
        msg: '',
      },
      rules: {
        msg: [
          { required: true, message: "请填写附言"},
          { validator: checkUserInput, message: "留言不能超过100字"}
        ]
      },
      tips: {
        title: '提示',
        tipsMsg: '提交成功！等待企业与您联系。',
        duration: 2000,
      },
      // 展示弹窗登录
      showLogin: false,
    };
  },
  methods: {
    getInfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/detail`, {
        parkId: this.currentParkId,
        id: this.$route.query.id,
      }).then((res) => {
        if (res.data.resCode = '10000') {
          this.detalisInfo = res.data.resData.pageInfo ? res.data.resData.pageInfo : {};
          this.showBigPic(0);
        }
      });
    },
    showBigPic(index) {
      this.action = index;
      this.imgUrl = this.detalisInfo.thumb[index].img;
    },
    showMask() {
      if (this.token) {
        this.showMaskFlag = true;
      } else {
        this.showLogin = true;
      }
    },
    reset() {
      this.showMaskFlag = false;
      this.$refs.call.resetFields();
    },
    cancel() {
      this.reset();
    },
    submit(fromName) {
      this.$refs[fromName].validate((valid) => {
        if (valid) {
          this.submitRequest();
        } else {
          return false;
        }
      });
    },
    submitRequest() {
      this.$http.post(`${this.URL_PREFIX}/app/added/shop/order`, {
        parkId: this.currentParkId,
        remark: this.call.msg,
        productId: this.$route.query.id,
      }, {
        headers: { token: this.token, }
      }).then((response) => {
        const res = response.data;
        this.reset();
        if (res.resCode !== '10000') {
          this.tips.tipsMsg = res.resDesc;
        }
        this.submitSuccessFlag=true;
      });
    },
  },
  created() {
    this.getInfo();
  },
  mounted () {
    this.$emit('set-search-bar', false)
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
  beforeRouteLeave(to, from, next){
    this.$emit('set-search-bar', true)
    next()
  }
}
</script>
<style lang="scss" scoped>
@import "~@scss";

.ProductDetalis{
  width: 1200px;
  // height: 580px;
  margin: 0 auto;
  .headerBar{
    display: flex;
    background-color: #fff;
    .imgPic{
      width: 580px;
      height: 580px;
      background-color: #fff;
      display: inline-block;
      vertical-align: middle;
    }
    .detalisInfo{
      display: inline-block;
      vertical-align: middle;
      flex: 1;
      padding: 22px 30px;
      box-sizing: border-box;
      .detalisTitle{
        font-size: 30px;
        font-weight: bold;
        color: #333;
        margin-bottom: 5px;
        // min-height: 100px;
      }
      .detalisText{
        font-size: 16px;
        color: #666;
        p{
          // margin-top: 10px;
          span{
            color: #333;
            // label {
            //   border: 1px solid #999999;
            //   border-radius: 4px;
            // }
          }
        }
      }
      .detalisPrice{
        // margin-top: 20px;
        font-size: 16px;
        span{
          color: #de2c32;
          font-size: 18px;
          font-weight: 600;
        }
      }
      .corpName{
        font-size: 16px;
        // margin-top: 10px;
      }
      .submitBtn{
        width: 134px;
        height: 40px;
        background-color: #de2c32;
        color: #fff;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 5px;
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }
  .imgList{
    width: 580px;
    margin-top: 20px;
    img{
      width: 100px;
      height: 100px;
      float: left;
      margin-right: 10px;
      cursor: pointer;
      box-sizing: border-box;
      &:nth-of-type(5n){
        margin-right: 0;
      }
      &.active{
        border: 1px solid #de2c32;
      }
    }
  }
  .content{
    // background-color: #fff;
    margin-top: 40px;
    padding: 10px 0;
    box-sizing: border-box;
    .contentTitle{
      font-size: 18px;
    }
    .contentText{
      margin-top: 22px;
      img{
        max-width: 100% !important;
      }
    }
  }
  .mask{
    @include mask;
    .container{
      width: 80%;
      max-width: 400px;
      .call_form{
        .btngroup{
          text-align: center;
        }
        .cancel, .confirm{
          padding: 8px 40px;
        }
        .cancel{
          color: #d0011b;
          border-color: #d0011b;
        }
        .cancel:hover{
          background: #d0011b;
          color: #FFFFFF;
          border-color: #d0011b;
        }
        .confirm{
          background: #d0011b;
          color: #FFFFFF;
          border-color: #d0011b;
        }
        .confirm:hover{
          background: #ffffff;
          color: #d0011b;
          border-color: #d0011b;
        }
      }
    }
  }
  .submit-success {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/components/detalis/ProductDetalis.vue